





































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers } from '@/mixins';
import {
  ScriveTemplateModel,
  BaseResultModel,
  ScriveTemplateConfigurationModel,
  ArenaSignTemplateCreateUpdateModel,
  Configuration,
  Dictionary
} from '@/types';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';

export default Vue.extend({
  name: 'ScriveAddTemplate',
  mixins: [FormFieldValidation, RouteHelpers],
  data() {
    return {
      isLoading: true,
      scriveSignTemplate: {} as ArenaSignTemplateCreateUpdateModel,
      docuSignTemplateConfigurationModel: {} as ScriveTemplateConfigurationModel,
      templateId: null,
      submitIsLoading: false,
      saveAndAddPartySubmitting: false,
      hasError: false,
      errorMessage: ''
    };
  },

  methods: {
    async onSubmit(this: any, setSubmittingState: (state: boolean) => void, navigate: () => void) {
      this.resetFormValidation();
      try {
        setSubmittingState(true);

        const result: BaseResultModel = await ScriveConfigurationService.createTemplateAsync({
          documentTypeId: this.documentTypeId,
          template: this.scriveSignTemplate.template
        } as ArenaSignTemplateCreateUpdateModel);

        if (result.hasNotification && !result.showToast) {
          this.addFormValidationError(result.notification);
          setSubmittingState(false);
          return;
        }

        this.templateId = result.id;

        SnotifyConfiguration.showSuccess('Template created successfully.');
        this.setApplicationDirty(false);
        navigate();
      } catch (error) {
        this.$log('Error creating template', error);
      } finally {
        setSubmittingState(false);
      }
    },
    async getDataAsync(this: any) {
      this.isLoading = true;
      try {
        this.docuSignTemplateConfigurationModel = await ScriveConfigurationService.getTemplateConfigurationAsync({
          documentTypeId: this.documentTypeId,
          templateId: null
        });
      } catch (error) {
        this.$log('Error getting template');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToTemplateTabManagement();
    },
    navigateToTemplateTabManagement(this: any) {
      this.navigateToRoute(Configuration.Scrive.Template.Management.name, this.documentTypeId);
    },
    navigateToAddSigningParty(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.Scrive.SigningParty.Add.name,
        params: param
      });
    },
    setSaveSubmittingState(this: any, state: boolean) {
      this.submitIsLoading = state;
    },
    setSaveAndAddPartySubmittingState(this: any, state: boolean) {
      this.saveAndAddPartySubmitting = state;
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    }
  },
  mounted(this: any) {
    this.getDataAsync();
  },
  components: {
    LoadingSpinner,
    MStoreTable,
    MStoreSpinnerButton
  }
});
